import prague from "../../img/prague.jpg";
import newyork from "../../img/newyork.jpg";
import riodejaneiro from "../../img/riodejaneiro.jpg";
import moscow from "../../img/moscow.webp";
import london from "../../img/london.webp";

const cityImages = {
  Prague: prague,
  "New York": newyork,
  Moscow: moscow,
  London: london,
  "Rio de Janeiro": riodejaneiro
};

export default cityImages;
